import { Temporal } from 'temporal-polyfill'
import type { DateOnly } from '@/features/domaine/types/techniques'

function checkDateFormat(value: any): value is string {
  if (typeof value !== 'string') return false
  return /^\d{4}-\d{2}-\d{2}/.test(value)
}

export function isDate(value: DateOnly | null | undefined): value is DateOnly {
  return plainDateFromDateOnly(value) !== null
}

export function plainDateFromDateOnly(value: DateOnly | null | undefined): Temporal.PlainDate | null {
  if (!checkDateFormat(value)) return null
  // Pour le moment, il n'existe pas d'autre moyen de vérifier
  // si la date est valide avec les classes de l'api Temporal
  try {
    return Temporal.PlainDate.from(value)
  } catch {
    return null
  }
}
